import { Vue, Watch, Component, Prop } from 'vue-property-decorator';
import { groupBy, isString, result } from 'lodash';
import editProductGroup from '../editProductGroup';
import { IPSService } from '@/services/ipsServices';
import bindClassDialog from '@/views/components/newDisplayConfig/bindClassDialog';
import activityLink from '@/views/components/linkForm/activityLink';
import interactive from '@/views/components/linkForm/interactive';
import assembleLink from '@/views/components/linkForm/assembleLink';
import { goodsGroupDialog } from '@/views/components/goodsGroup';
import goodsLink from '@/views/components/linkForm/goodsLink';
import liveLink from '@/views/components/linkForm/liveLink';
import periodicalLink from '@/views/components/linkForm/periodicalLink';
import promotionLink from '@/views/components/linkForm/promotionLink';
import skillLink from '@/views/components/linkForm/skillLink';
import miniPageLink from '@/views/components/linkForm/miniPage';
import otherAppLink from '@/views/components/linkForm/otherApp';
import couponLink from '@/views/components/linkForm/coupon';
import weChatMessageLink from '@/views/components/linkForm/WeChatMessage';
import SkillGroupLink from '@/views/components/linkForm/skillGroupLink';

import ChooseGoodsClass from '@/views/components/chooseGoodsClass';
import Upload from '@/views/components/upload/upload.vue';
import { QinggerLibUtils, noop } from '@/util';
// 1期刊、2商品、3商品分类、4直播活动、5秒杀活动、6团购活动、7活动、8促销、9商品组、10新促、11自定义微页面、12优惠券、13其他小程序、14购物车、15联系客服 、16.分享 、17.互动活动 、18.发售 、19.秒杀组活动
export enum LINK_TYPE {
  QIKAN = 1,
  GOOD,
  GOOD_CLASS,
  LIVE,
  KILL,
  ASSEMBLE,
  ACTIVE,
  PROMOTION,
  GOOD_GROUP,
  NEW_PROMOTION,
  MINI_PAGE,
  COUPON,
  OTHER_APP,
  CART,
  GUIDE,
  SHARE,
  INTERACTIVE,
  SALE,
  KILL_GROUP,
  PUSH_MESSAGE,
  JOIN_MEMBER=22
}

export const linkTypes = [
  { value: LINK_TYPE.JOIN_MEMBER, label: '入会' },
  { value: LINK_TYPE.QIKAN, label: '期刊' },
  { value: LINK_TYPE.GOOD, label: '商品' },
  { value: LINK_TYPE.GOOD_CLASS, label: '商品分类' },
  { value: LINK_TYPE.GOOD_GROUP, label: '商品组' },
  { value: LINK_TYPE.LIVE, label: '直播活动' },
  { value: LINK_TYPE.KILL, label: '秒杀活动' },
  { value: LINK_TYPE.KILL_GROUP, label: '秒杀组活动' },
  { value: LINK_TYPE.ASSEMBLE, label: '团购活动' },
  { value: LINK_TYPE.INTERACTIVE, label: '互动活动' },
  { value: LINK_TYPE.SALE, label: '发售活动列表' },
  { value: LINK_TYPE.ACTIVE, label: '发售活动' },
  { value: LINK_TYPE.PROMOTION, label: '促销活动' },
  { value: LINK_TYPE.MINI_PAGE, label: '自定义微页面' },
  { value: LINK_TYPE.COUPON, label: '优惠券' },
  { value: LINK_TYPE.OTHER_APP, label: '小程序页面' },
  { value: LINK_TYPE.PUSH_MESSAGE, label: '公众号推文' },
  { value: LINK_TYPE.CART, label: '购物车' },
  { value: LINK_TYPE.GUIDE, label: '统一客服' },
  { value: LINK_TYPE.SHARE, label: '分享' },
  // 此促销放最后
  { value: LINK_TYPE.NEW_PROMOTION, label: '促销' },
];

interface Link {
  linkId?: number | string | { classIds?: number[] }[] | any;
  linkType?: number;
  linkDesc?: string;
  hotPosition?: { x?: number; y?: number; height?: number; width?: number; yPercent?: number; hPercent?: number; xPercent?: number; wPercent?: number };
  couponInfo?: { cplId?: string | number; couponCover?: string; points?: string | number };
  jumpPath?: {
    appName?: string;
    pagePath?: string;
  };
  officialAccount?: {
    accountTitle?: string;
    accountUrl?: string;
  };
  actType?: string;
  productSort?: number;
  shareImage?: string;
  shareInfo?: string;
}

const isset = QinggerLibUtils.isset;

@Component({
  components: { Upload },
})
export default class LinkForm extends Vue {
  @Prop()
  value: Link;

  // 1 2 3
  @Prop({ default: 0 })
  state: number;

  @Prop()
  sgId: number;

  @Prop({ default: () => [] })
  siteCodes: Array<string>;

  @Prop()
  empCode: string;

  @Prop({ default: '链接至' })
  linkText: string;

  // false弹窗向上，true向上
  @Prop({ default: false })
  hotarea: boolean;

  // 字体变小，间距变窄
  @Prop({ default: true })
  hotAd: boolean;

  @Prop()
  fromPage: number;

  @Prop()
  indexIcon: number;

  // 是否i展示前端筛选
  @Prop({ default: false })
  sortShow: boolean;

  // 是否使用默认footer
  @Prop({ default: true })
  dialogFooter: boolean;

  // 运营模式 1镜像店  2云商城
  @Prop({ default: 1 })
  mode: number;

  // 0单店 1千店
  @Prop()
  isMoreSite: number;

  // 网点组 商品分类列表
  @Prop({ default: () => [] })
  attributeList: ItemArray;

  // // 网点 分类列表
  // @Prop({ default: () => [] })
  // goodsClassList: ItemArray;

  // 网点Id
  @Prop({ default: 0 })
  siteId: number;

  @Prop({ default: '120px' })
  labelWidth

  /**
   * 排除链接项
   * @type {number[]}
   */
  @Prop({ default: () => [14, 15, 16] })
  exclude: number[];

  linkValue: Link = {
    linkId: 0,
    linkType: 0,
    linkDesc: '',
    hotPosition: {
      x: 10,
      y: 10,
      height: 50,
      width: 50,
    },
    couponInfo: {
      cplId: '',
      couponCover: '',
      points: 1,
    },
    jumpPath: {
      appName: '',
      pagePath: '',
    },
    officialAccount: {
      accountTitle: '',
      accountUrl: '',
    },
  };

  linkSelect = [];

  linkType = 0;

  baseTemp = {
    linkId: 0,
    linkType: 0,
    linkDesc: '',
    hotPosition: {
      x: 10,
      y: 10,
      height: 50,
      width: 50,
    },
    couponInfo: {
      cplId: '',
      couponCover: '',
      points: 1,
    },
    jumpPath: {
      appName: '',
      pagePath: '',
    },
    officialAccount: {
      accountTitle: '',
      accountUrl: '',
    },
  };

  hiddenCloseIcon = [LINK_TYPE.CART, LINK_TYPE.GUIDE, LINK_TYPE.SHARE, LINK_TYPE.SALE, LINK_TYPE.JOIN_MEMBER];

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) != JSON.stringify(o)) {
      this.linkValue = Object.assign({}, this.baseTemp, n);
      this.linkType = this.linkValue.linkType;
      if (this.linkType === LINK_TYPE.OTHER_APP) {
        this.linkValue.linkDesc = `【${this.linkValue.jumpPath.appName}】 ${this.linkValue.linkId}-${this.linkValue.jumpPath.pagePath}`;
      }
    }
  }

  mounted() {
    this.linkSelect = linkTypes.slice(0, - 1);
    this.linkSelect = this.linkSelect.filter(v => !this.exclude.includes(v.value));
  }

  linkTypeText(linkType) {
    const linkItem = linkTypes.find(v => v.value === linkType);
    return linkItem ? linkItem.label : '';
  }

  handleDeleteSelect(code) {
    this.mode == 1 ? this.deleteSgClassSelect(code) : this.deleteSiteSelect(code);
  }

  deleteSiteSelect(code: Array<string>) {
    if (code && code.length) {
      const codeList = (this.linkValue.linkId as string).split('_').join(',').split(',');
      this.linkValue.linkId = codeList.filter(v => !code.includes(v)).join(',');
      // 原始代码
      // let codeList: string[][] = (this.linkValue.linkId as ItemArray).map((v) => v.classIds);
      // codeList = codeList.map((v) => {
      //   v = v.filter((val) => !code.includes(Number(val)));
      //   return v;
      // });
      // (this.linkValue.linkId as ItemArray) = codeList.map((v) => {
      //   return {
      //     classIds: v,
      //   };
      // });
      if (!this.linkValue.linkId || !this.linkValue.linkId.length) {
        this.linkValue = Object.assign(this.linkValue, { linkId: 0, linkType: 0, linkDesc: '' });
        this.linkType = 0;
        this.$emit('input', this.linkValue);
      } else {
        this.onSelect(this.linkValue);
      }
    } else {
      this.linkValue = Object.assign(this.linkValue, { linkId: 0, linkType: 0, linkDesc: '' });
      this.linkType = 0;
      this.$emit('input', this.linkValue);
    }
  }

  deleteSgClassSelect(code: Array<string>) {
    if (code && code.length) {
      const codeList = (this.linkValue.linkId as string).split('_').join(',').split(',');
      this.linkValue.linkId = codeList.filter(v => !code.includes(v)).join(',');
      if (!this.getClassDesc() || !this.getClassDesc().length) {
        this.linkValue = Object.assign(this.linkValue, { linkId: 0, linkType: 0, linkDesc: '' });
        this.linkType = 0;
      }
      this.onSelect(this.linkValue);
    } else {
      this.linkValue = Object.assign(this.linkValue, { linkId: 0, linkType: 0, linkDesc: '' });
      this.linkType = 0;
      this.$emit('input', this.linkValue);
    }
  }

  handleSelectChange(linkType) {
    switch (linkType) {
      case LINK_TYPE.QIKAN:
        periodicalLink.open({ sgId: this.sgId, siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【期刊】${result.id}-${result.name}`,
            linkType: LINK_TYPE.QIKAN,
          });
        }, noop);
        break;
      case LINK_TYPE.GOOD:
        let params = {};
        if (this.mode == 2) {
          params = { siteId: this.siteId, isCloudMall: 1 };
        }
        goodsLink.open({ params }).then((result) => {
          this.onSelect({
            linkId: result[0].productCode,
            linkDesc: `【商品】${result[0].productCode}-${result[0].productName}`,
            linkType: LINK_TYPE.GOOD,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.GOOD_CLASS:
        let defaultCheckedKeys = [];
        if (isString(this.linkValue.linkId)) {
          defaultCheckedKeys = this.linkValue.linkId.split('_').join(',').split(',');
        }
        bindClassDialog.open({ defaultCheckedKeys, sortShow: this.sortShow, footer: this.dialogFooter, sortValue: this.linkValue?.productSort || 1, shareImage: this.linkValue?.shareImage, shareInfo: this.linkValue?.shareInfo }).then((result) => {
          this.onSelect({
            linkId: (this.sortShow ? result.selectList : result)
              .filter(v => v.isLeafe)
              .map(val => val.value_no)
              .join(','),
            linkType: LINK_TYPE.GOOD_CLASS,
            linkDesc: this.sortShow ? `已选择${result.selectList.length}个商品分类` : '',
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
            productSort: result.sortValue ?? 1,
            shareImage: result.shareImage,
            shareInfo: result.shareInfo,
          });
        }, noop);
        break;
      case LINK_TYPE.LIVE:
        liveLink.open({ sgId: this.sgId, siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【直播】${result.id}-${result.name}`,
            linkType: LINK_TYPE.LIVE,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.KILL:
        skillLink.open({ siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【秒杀】${result.id}-${result.name}`,
            linkType: LINK_TYPE.KILL,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.KILL_GROUP:
        SkillGroupLink.open({ siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【秒杀组】${result.id}-${result.name}`,
            linkType: LINK_TYPE.KILL_GROUP,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.ASSEMBLE:
        assembleLink.open({ siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【团购】${result.id}-${result.name}`,
            linkType: LINK_TYPE.ASSEMBLE,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.ACTIVE:
        activityLink.open({ siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【活动】${result.id}-${result.name}`,
            linkType: LINK_TYPE.ACTIVE,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.PROMOTION:
      case LINK_TYPE.NEW_PROMOTION:
        promotionLink.open({ siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【促销】${result.id}-${result.name}`,
            linkType: result.linkType,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.GOOD_GROUP:
        let productCodes = '';
        this.linkValue.linkType === LINK_TYPE.GOOD_GROUP && (productCodes = typeof this.linkValue.linkId === 'string' ? (this.linkValue.linkId as string) : this.linkValue.linkId);
        const { shareImage, shareInfo } = this.linkValue
        const sortValue = this.linkValue.productSort === null || !this.linkValue.productSort ? null : this.linkValue?.productSort || 1;
        if (this.sortShow) {
          editProductGroup.open({ productCodes, empCode: this.empCode, siteId: this.siteId, isCloudMall: Number(this.mode == 2), sortValue, shareImage, shareInfo }).then((result) => {
            this.onSelect({
              linkId: result.list.map((v) => {
                return { c: v.productCode, s: v.sort };
              }),
              linkDesc: `已选择${result.list.length}件商品`,
              linkType: LINK_TYPE.GOOD_GROUP,
              couponInfo: {},
              jumpPath: {},
              officialAccount: {},
              productSort: result.productSort === null ? null : result.productSort || 1,
              shareImage: result.shareImage,
              shareInfo: result.shareInfo,
            });
          }, noop);
        } else {
          goodsGroupDialog.open({ productCodes, empCode: this.empCode, siteId: this.siteId, isCloudMall: Number(this.mode == 2) }).then((result) => {
            this.onSelect({
              linkId: result.list,
              linkDesc: `【商品组】- 已选择${result.list.split(',').length}个商品`,
              linkType: LINK_TYPE.GOOD_GROUP,
              couponInfo: {},
              jumpPath: {},
              officialAccount: {},
            });
          }, noop);
        }

        break;
      case LINK_TYPE.MINI_PAGE:
        miniPageLink.open({ sgId: this.sgId, siteCodes: this.siteCodes, mode: this.mode, siteId: this.siteId }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【微页面】${result.id}-${result.name}`,
            linkType: LINK_TYPE.MINI_PAGE,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      // 小程序
      case LINK_TYPE.OTHER_APP:
        const linkAppInfo = {
          appName: this.linkValue.linkType === LINK_TYPE.OTHER_APP ? this.linkValue.jumpPath.appName || '' : '',
          pagePath: this.linkValue.linkType === LINK_TYPE.OTHER_APP ? this.linkValue.jumpPath.pagePath || '' : '',
          appId: this.linkValue.linkType === LINK_TYPE.OTHER_APP ? this.linkValue.linkId || '' : '',
        };
        otherAppLink.open({ linkAppInfo }).then((result) => {
          this.onSelect({
            linkId: result.appId,
            linkDesc: `【${result.appName}】 ${result.appId}-${result.pagePath}`,
            linkType: LINK_TYPE.OTHER_APP,
            jumpPath: {
              appName: result.appName,
              pagePath: result.pagePath,
            },
            couponInfo: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.COUPON:
        couponLink.open({ siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: 0,
            linkDesc: `【${result.type}】${result.id}-${result.name}`,
            linkType: LINK_TYPE.COUPON,
            couponInfo: { cplId: result.id },
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;

      case LINK_TYPE.INTERACTIVE:
        interactive.open({ siteId: this.siteId, siteCodes: this.siteCodes }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【互动活动】${result.id}-${result.name}`,
            linkType: LINK_TYPE.INTERACTIVE,
            actType: result.type,
            couponInfo: {},
            jumpPath: {},
            officialAccount: {},
          });
        }, noop);
        break;
      case LINK_TYPE.SALE:
        this.onSelect({ linkId: 0, linkDesc: '', linkType: LINK_TYPE.SALE, couponInfo: {}, jumpPath: {}, officialAccount: {} });
        break;
      case LINK_TYPE.PUSH_MESSAGE:
        const linkArticleInfo = {
          articleTitle: this.linkValue.linkType === LINK_TYPE.PUSH_MESSAGE ? this.linkValue.officialAccount.accountTitle || '' : '',
          articleAddress: this.linkValue.linkType === LINK_TYPE.PUSH_MESSAGE ? this.linkValue.officialAccount.accountUrl || '' : '',
          // id: this.linkValue.linkType === LINK_TYPE.PUSH_MESSAGE ? this.linkValue.linkId || "" : "",
        };
        weChatMessageLink.open({ linkArticleInfo }).then((result) => {
          this.onSelect({
            linkId: result.id,
            linkDesc: `【公众号推文】${result.name}`,
            linkType: LINK_TYPE.PUSH_MESSAGE,
            officialAccount: {
              accountTitle: result.name,
              accountUrl: result.url,
            },
            couponInfo: {},
            jumpPath: {},
            // weChatInfo:"",
          });
        }, noop);

        break;
      case LINK_TYPE.CART:
        this.onSelect({ linkId: 0, linkDesc: '', linkType: LINK_TYPE.CART, couponInfo: {}, jumpPath: {}, officialAccount: {} });
        break;
      case LINK_TYPE.GUIDE:
        this.onSelect({ linkId: 0, linkDesc: '', linkType: LINK_TYPE.GUIDE, couponInfo: {}, jumpPath: {}, officialAccount: {} });
        break;
      case LINK_TYPE.SHARE:
        this.onSelect({ linkId: 0, linkDesc: '', linkType: LINK_TYPE.SHARE, couponInfo: {}, jumpPath: {}, officialAccount: {} });
        break;
      case LINK_TYPE.JOIN_MEMBER:
        this.onSelect({ linkId: 0, linkDesc: '', linkType: LINK_TYPE.JOIN_MEMBER, couponInfo: {}, jumpPath: {}, officialAccount: {} });
        break;
      default:
        break;
    }
  }

  /**
   * 获取商品分类desc
   */
  public getClassDesc() {
    return this.getSgClassDesc();
  }

  // public getSiteClassDesc() {
  //   let classIds: any[] = isString(this.linkValue.linkId) ? this.linkValue.linkId.split("_").join(",").split(",") : (this.linkValue.linkId as any[]).map((v) => v.classIds).flat();
  //   classIds = classIds.map((v) => Number(v));
  //   const result = [];
  //   const childrenStore = this.goodsClassList.map((v) => v.children).flat();
  //   const childrenList = childrenStore.filter((v) => classIds.includes(v.classId));
  //   const groupClassList = groupBy(childrenList, "parentId");
  //   Object.keys(groupClassList).map((k) => {
  //     const item = {
  //       class_code: k,
  //       class_name: "",
  //       value_no: [],
  //       value_name: [],
  //     };
  //     const parent = this.goodsClassList.find((v) => v.classId === (groupClassList[k][0] ? groupClassList[k][0].parentId : 0));
  //     item.class_name = "【商品分类】" + (parent ? parent.className : "**");
  //     item.value_no = groupClassList[k].map((g) => g.classId);
  //     item.value_name = groupClassList[k].map((g) => g.className);
  //     result.push(item);
  //   });
  //   return result;
  // }

  // 获取网点分类Desc
  public getSgClassDesc() {
    const codes = isString(this.linkValue.linkId) ? this.linkValue.linkId.split('_').join(',').split(',') : [];
    const lacssList = [];
    const result = [];
    this.attributeListStore.forEach((i) => {
      if (codes.includes(i.value_no)) {
        lacssList.push(i);
      }
    });
    const groupClassList = groupBy(lacssList, 'class_code');
    Object.keys(groupClassList).forEach((v) => {
      const item = {
        class_code: v,
        class_name: '',
        value_no: [],
        value_name: [],
      };
      item.class_name = `【商品分类】${groupClassList[v][0].class_name}`;
      item.value_no = groupClassList[v].map(g => g.value_no);
      item.value_name = groupClassList[v].map(g => g.value_name);
      result.push(item);
    });

    return result;
  }

  get attributeListStore() {
    return this.computedTree(this.attributeList);
  }

  computedTree(list = [], result = []) {
    list.forEach((v) => {
      const item = {
        class_code: '',
        class_name: '',
        value_no: '',
        value_name: '',
      };
      item.class_code = v.attrCode || v.class_code;
      item.class_name = v.attrCode ? v.attrName : this.attributeList.find(v => v.attrCode === item.class_code).attrName;
      item.value_no = v.attrCode || v.value_no;
      item.value_name = v.attrName || v.value_name;
      result.push(item);
      if (v.list && v.list.length) {
        this.computedTree(v.list, result);
      }
    });
    return result;
  }

  onSelect(linkValue: Link, temp = {}) {
    this.linkType = linkValue.linkType;
    this.linkValue = Object.assign({}, this.linkValue, linkValue);
    let classLinkId = this.linkValue.linkId;
    if (this.linkType === LINK_TYPE.GOOD_CLASS) {
      classLinkId = this.getClassDesc()
        .map(g => g.value_no.join(','))
        .join('_');
    }
    this.$emit('input', Object.assign({}, this.linkValue, { linkId: classLinkId }));
    this.onLinkComChange(Object.assign({}, this.linkValue, { linkId: classLinkId }));
  }

  onLinkComChange(linkValue) {
    this.$emit('change', linkValue);
  }

  uploadImgSuccess(res: HttpAPIRetItem<any>) {
    this.linkValue.couponInfo.couponCover = res.content;
    this.onSelect(this.linkValue);
  }

  onInputPoints(val) {
    this.onSelect(this.linkValue);
  }
}
